import { render } from "./Pedometer.vue?vue&type=template&id=6e9082ca&scoped=true"
import script from "./Pedometer.vue?vue&type=script&lang=js"
export * from "./Pedometer.vue?vue&type=script&lang=js"

import "./Pedometer.vue?vue&type=style&index=0&id=6e9082ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9082ca"]])

export default __exports__